// Anfrage-Formular für die festen Service-Angebote. KEIN Backend — „Senden" stellt
// eine vorausgefüllte E-Mail (mailto) zusammen; Vorauswahl kommt per URL-Query.
import { useState } from "react";
import { useSearchParams, NavLink } from "react-router-dom";
import { ArrowLeft, Send } from "lucide-react";

const ANLIEGEN = [
  ["website-optimierung", "Website-Optimierung"],
  ["ki-agentensystem", "KI-Agentensystem aufbauen"],
  ["prozesse-automatisieren", "Prozesse automatisieren"],
  ["enterprise-paket", "Enterprise-Paket (individuelle Anfrage)"],
];
const USECASES = ["Unternehmen mit Website", "E-Commerce", "Dienstleister & Berater", "Interne Prozessautomatisierung", "Sonstiges"];
const TEMPLATES = {
  "website-optimierung": "Ich interessiere mich für die Website-Optimierung (ab 79 €/Monat).\n\nMeine Website: \nMein Ziel: ",
  "ki-agentensystem": "Ich möchte ein KI-Agentensystem wie bei Förderfuchs aufbauen.\n\nUnser Unternehmen: \nWas wir automatisieren möchten: ",
  "prozesse-automatisieren": "Ich möchte individuelle Unternehmensabläufe automatisieren.\n\nProzess/Ablauf: \nAktueller Aufwand: ",
  "enterprise-paket": "Ich interessiere mich für ein individuelles Enterprise-Paket des KI Social Media Managers.\n\nUnser Unternehmen/Team: \nAnzahl Marken bzw. Kunden: \nGewünschte Kanäle & Posting-Volumen: \nBesondere Anforderungen (z. B. White-Label, Sonderworkflows): ",
};

export default function KontaktPage() {
  const [sp] = useSearchParams();
  const a0 = ANLIEGEN.some((a) => a[0] === sp.get("anliegen")) ? sp.get("anliegen") : ANLIEGEN[0][0];
  const u0 = USECASES.includes(sp.get("usecase")) ? sp.get("usecase") : USECASES[0];
  const [anliegen, setAnliegen] = useState(a0);
  const [useCase, setUseCase] = useState(u0);
  const [text, setText] = useState(TEMPLATES[a0] || "");

  const label = ANLIEGEN.find((a) => a[0] === anliegen)?.[1] || "Anfrage";
  const send = () => {
    const body = `Anliegen: ${label}\nUse Case: ${useCase}\n\n${text}`;
    window.location.href = `mailto:schuchardt@foerderfuchs-bildung.de?subject=${encodeURIComponent("Anfrage: " + label)}&body=${encodeURIComponent(body)}`;
  };
  const f = "mt-1 w-full rounded-lg border border-stone-300 px-3 py-2 text-sm focus:border-fox-fire outline-none";

  return (
    <div className="max-w-2xl mx-auto space-y-6 animate-fade-in">
      <NavLink to="/pricing" className="text-sm text-fox-fire hover:underline inline-flex items-center gap-1">
        <ArrowLeft size={14} /> Zurück zu den Angeboten
      </NavLink>
      <div>
        <h1 className="font-heading text-3xl font-bold text-stone-900">Kostenlos &amp; unverbindlich anfragen</h1>
        <p className="text-stone-500 mt-1">Erzähl uns kurz, worum es geht — wir melden uns mit einem konkreten Vorschlag.</p>
      </div>
      <div className="panel-card p-6 space-y-4">
        <label className="block text-sm font-semibold text-stone-700">Anliegen
          <select value={anliegen} onChange={(e) => { setAnliegen(e.target.value); setText(TEMPLATES[e.target.value] || ""); }} className={f} data-testid="kontakt-anliegen">
            {ANLIEGEN.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        </label>
        <label className="block text-sm font-semibold text-stone-700">Use Case
          <select value={useCase} onChange={(e) => setUseCase(e.target.value)} className={f} data-testid="kontakt-usecase">
            {USECASES.map((u) => <option key={u} value={u}>{u}</option>)}
          </select>
        </label>
        <label className="block text-sm font-semibold text-stone-700">Beschreibung
          <textarea value={text} onChange={(e) => setText(e.target.value)} rows={6} className={f} data-testid="kontakt-text" />
        </label>
        <button onClick={send} data-testid="kontakt-send"
          className="w-full bg-fox-fire hover:bg-fox-fire-dark text-white font-semibold py-2.5 rounded-xl flex items-center justify-center gap-2 transition-colors">
          <Send size={16} /> Anfrage per E-Mail senden
        </button>
        <p className="text-xs text-stone-400 text-center">
          Öffnet dein E-Mail-Programm mit vorausgefüllter Nachricht an schuchardt@foerderfuchs-bildung.de.
        </p>
      </div>
    </div>
  );
}
